export default function TComponent({ componentFn, attribute, item }) {
  const component = componentFn && componentFn(item);

  return <td> {component ?? attribute?.id ?? attribute} </td>;
}
